
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'checkout-summary',
  components: {
    CheckoutSummaryPersonalAddress: require('./personal/address.vue').default,
  },
})
export default class extends Vue {
  private get customerEmail(): string {
    return this.$store.getters['CheckoutGlobal/customerEmail'] || '';
  }

  private get customerIsBusinessAccount(): string {
    return this.$store.getters['CheckoutGlobal/isBusinessAccount'] || '';
  }

  private get customerAddressInformation(): object {
    return this.$store.getters['CheckoutAddress/shippingAddress'];
  }

  private get cartTotals(): object {
    return this.$store.getters['CheckoutTotals/cartTotals'];
  }

  private get currentPaymentMethodIsQuotation(): boolean {
    let payment = this.$store.getters['CheckoutPayment/selectedPaymentMethod'];
    return 'quotation' === payment['code'] && this.totalsAvailable;
  }

  private get totalsAvailable(): boolean {
    return this.$store.getters['CheckoutTotals/totalsAvailable'];
  }

  private get cartItems(): object {
    return this.$store.getters['CheckoutTotals/cartItems'];
  }

  private getPrice(priceKey): number {
    if (typeof this.cartTotals[priceKey] === 'undefined') {
      return 0; // Price not available
    }

    return this.cartTotals[priceKey];
  }

  private get getGrandTotalWithoutTax(): number
  {
    return this.getPrice('grand_total') - this.getPrice('tax_amount');
  }

  private gotoStep(step): void {
    this.$store.dispatch('CheckoutGlobal/gotoStep', step);
  }
}
